(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1-featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Support multiple Star Product sections on a page
    document.querySelectorAll('.star-product').forEach((section) => {
      const swiperEl = section.querySelector('.star-product-media');
      const triggers = Array.from(section.querySelectorAll('.variant-trigger'));
      const form = section.querySelector('.star-product-atc');
      const idInput = form?.querySelector('input[name="id"]');
      const qtyInput = form?.querySelector('input[name="quantity"]');
      const atcBtn = form?.querySelector('.atc-button');
      const statusEl = form?.querySelector('.atc-status');

      // Init Swiper (fixed height via CSS to avoid jump)
      let swiper;
      function makeSwiper() {
        if (!swiperEl) return;
        // avoid double-init
        if (swiperEl.__swiper) {
          swiper = swiperEl.__swiper;
          return;
        }
        swiper = new Swiper(swiperEl, {
          // autoHeight: false
        });
        swiperEl.__swiper = swiper;
      }

      if (window.Swiper) makeSwiper();
      else window.addEventListener('load', makeSwiper, { once: true });

      // Helpers
      const setActive = (index) => {
        // Set active button
        triggers.forEach((btn) => btn.classList.remove('is-active'));
        const active = triggers.find((btn) => Number(btn.dataset.slideIndex) === index);
        if (active) active.classList.add('is-active');

        // Update ATC target variant
        if (active && idInput && atcBtn) {
          idInput.value = active.dataset.variantId;
          const available = active.dataset.available === 'true';
          atcBtn.disabled = !available;
          atcBtn.textContent = available ? 'Add to cart' : 'Sold out';
        }
      };

      // Click a variant title → go to slide & update form
      triggers.forEach((btn) => {
        btn.addEventListener('click', () => {
          const index = Number(btn.dataset.slideIndex) || 0;
          if (swiper) {
            if (swiper.params.loop) swiper.slideToLoop(index);
            else swiper.slideTo(index);
          }
          setActive(index);
        });
      });

      // Swipe → sync active title & form
      if (swiper) {
        swiper.on('slideChange', () => {
          setActive(swiper.realIndex ?? swiper.activeIndex);
        });
      }

      // Initial
      setActive(swiper?.realIndex ?? 0);

      // Quantity controls
      if (qtyInput && form) {
        form.querySelector('[data-inc]')?.addEventListener('click', () => {
          qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) + 1);
        });
        form.querySelector('[data-dec]')?.addEventListener('click', () => {
          qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
        });
      }

      // AJAX Add to Cart (Dawn-like)
      if (form && idInput && qtyInput && atcBtn) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();

          const originalText = atcBtn.textContent;
          atcBtn.disabled = true;
          atcBtn.textContent = 'Adding...';
          if (statusEl) statusEl.textContent = '';

          // Dawn prefers cart-drawer if present, otherwise cart-notification
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

          // Build FormData like Dawn does
          const formData = new FormData(form);

          // Ensure we override with the currently selected variant + qty
          formData.set('id', idInput.value);
          formData.set('quantity', String(Math.max(1, parseInt(qtyInput.value || '1', 10))));

          // If cart UI exists, request section HTML so it can re-render itself
          if (cart && typeof cart.getSectionsToRender === 'function') {
            const sections = cart.getSectionsToRender().map((s) => s.id);
            formData.set('sections', sections.join(','));
            formData.set('sections_url', window.location.pathname);
          }

          try {
            const res = await fetch(window.Shopify?.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: formData,
              credentials: 'same-origin',
            });

            const response = await res.json().catch(() => ({}));

            if (!res.ok) {
              throw new Error(response?.description || response?.message || `Error ${res.status}`);
            }

            // If we have Dawn cart UI, let it render updated sections (bubble, drawer, etc.)
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            } else {
              // Fallback: update just cart bubble if no Dawn cart component exists
              // (common on themes where drawer/notification disabled)
              try {
                const bubbleRes = await fetch(`${window.location.pathname}?sections=cart-icon-bubble`, {
                  credentials: 'same-origin',
                });
                const sectionsJson = await bubbleRes.json();
                const html = sectionsJson['cart-icon-bubble'];
                if (html) {
                  const doc = new DOMParser().parseFromString(html, 'text/html');
                  const newBubble = doc.querySelector('#cart-icon-bubble');
                  const oldBubble = document.querySelector('#cart-icon-bubble');
                  if (oldBubble && newBubble) oldBubble.replaceWith(newBubble);
                }
              } catch (err) {
                // ignore bubble fallback errors
              }
            }

            atcBtn.textContent = 'Added ✓';
          } catch (err) {
            console.error(err);
            atcBtn.textContent = 'Try again';
            if (statusEl) statusEl.textContent = String(err.message || 'Unable to add to cart.');
          } finally {
            setTimeout(() => {
              atcBtn.disabled = false;
              atcBtn.textContent = originalText;
            }, 1200);
            if (cart && cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init() {
      const container = document.querySelector('.swiper.testimonials_swiper');
      if (!container) return; // not on this page
      if (container.__swiper) return; // avoid double init
      if (!container.querySelector('.swiper-wrapper')) return; // sanity

      container.__swiper = new Swiper(container, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 32,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },

          990: {
            slidesPerView: 3,
          },
        },
        pagination: { el: container.querySelector('.swiper-pagination'), clickable: true },
      });
    }

    function boot() {
      if (window.Swiper) init();
      else window.addEventListener('load', init, { once: true }); // wait for CDN script
    }

    // storefront
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    // Theme Editor: re-init when section is (re)loaded
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target.querySelector('.swiper.testimonials')) init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
